import { Order } from "../features/orders/model/types";

export const STATUS_TAGS: Record<string, { color: string; label: string, code: string }> = {
  pending: { color: "blue", label: "申請中", code: "pending" },
  waiting_final_confirmation: { color: "gold", label: "最終確認待", code: "waiting_final_confirmation" },
  confirmed: { color: "cyan", label: "最終確定済み", code: "confirmed" },
};

export const STATUS_PROPOSAL: Record<string, { color: string; label: string; code: string }> = {
  draft: { color: "gray", label: "社内検討中", code: "draft" },
  pending: { color: "green", label: "採用決定", code: "pending" },
  confirmed: { color: "gold", label: "見積提示済", code: "confirmed" },
};

export const generateMockOrders = (count: number = 55): Order[] => {
  const statuses: Order["status"][] = ["pending", "waiting_final_confirmation", "confirmed"];
  const stores = ["メイセイ店舗 A", "メイセイ店舗 B", "メイセイ店舗 C", "メイセイ店舗 D"];

  return Array.from({ length: count }, (_, i) => {
    const idx = i + 1;
    const numStr = idx < 10 ? `00${idx}` : idx < 100 ? `0${idx}` : `${idx}`;
    const status = statuses[i % statuses.length];
    const store = stores[i % stores.length];
    const amount = (i + 1) * 12500 + 35000;

    return {
      id: String(idx),
      orderNo: `ORD-2026-${numStr}`,
      customerName: store,
      orderDate: `2026-09-${String((i % 28) + 1).padStart(2, "0")}`,
      deliveryDate: `2026-09-${String((i % 28) + 3).padStart(2, "0")}`,
      status: status,
      totalAmount: amount,
      items: [
        {
          id: `item-${idx}-1`,
          productCode: "PRD-101",
          productName: "ワークシャツ タイプA",
          unitPrice: 2500,
          sizes: { S: (i % 5) + 1, M: (i % 8) + 2, L: 5, XL: 2, "3L": 0 },
        },
      ],
      notes: i % 3 === 0 ? "午前中配送希望" : undefined,
    };
  });
};

export const MOCK_ORDERS: Order[] = generateMockOrders(55);

export function formatDate(dateInput?: Date | string | number | null): string {
  if (!dateInput) return "";
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date.getTime())) {
    return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
}

export function formatDateDDMM(dateInput?: Date | string | number | null): string {
  if (!dateInput) return "";
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (isNaN(date.getTime())) {
    return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");

  return `${day}/${month}`;
}
